import { Injectable } from '@angular/core';
import { Response, Http } from "@angular/http";
import { AuthHttp } from "angular2-jwt/angular2-jwt";

import { UserService } from "./user.service";
import { AuthService } from "../../auth/auth.service";
import { LoadingSpinnerService } from "./loading-spinner.service";

import { SavedContactSearch } from "../models/saved-contact-search.model";
import { CrmUser } from "../models/user.model";

import 'rxjs/Rx';
import { Observable } from "rxjs/Observable";
import { Subject } from "rxjs/Subject";

import { AppSettings } from 'app.settings'
import { HttpClient } from '@angular/common/http';


@Injectable()
export class SavedContactSearchService {
  private url: string = AppSettings.API_ENDPOINT + 'api/savedContactSearches/';

  public savedContactSearchesChanged = new Subject();

  constructor(
    private http: HttpClient,
    private authService: AuthService,
    private userService: UserService,
    private loadingService: LoadingSpinnerService
  ) { }

  getSavedContactSearches(): Observable<SavedContactSearch[]> {
    //this.authService.reauthenticateIfTokenExpired();

    this.loadingService.displayLoadingSpinner();
    return this.http.get(this.url).map(
      (response: Response) => {
        let savedContactSearches: SavedContactSearch[] = (<any>response);
        savedContactSearches = savedContactSearches.map(
          cT => {
            // cT.createdByUserAccount = this.userService.getUser(cT.createdByUserAccountId);
            // cT.updatedByUserAccount = this.userService.getUser(cT.updatedByUserAccountId);
            return cT;
          }
        );
        return savedContactSearches;
      }
    ).finally(() => this.loadingService.hideLoadingSpinner());
  }

  getSavedContactSearch(id: number): Observable<SavedContactSearch> {
    //this.authService.reauthenticateIfTokenExpired();

    this.loadingService.displayLoadingSpinner();
    return this.http.get(this.url + id).map(
      (response: Response) => {
        let savedContactSearch: SavedContactSearch = (<any>response);
        // savedContactSearch.createdByUserAccount = this.userService.getUser(savedContactSearch.createdByUserAccountId);
        // savedContactSearch.updatedByUserAccount = this.userService.getUser(savedContactSearch.updatedByUserAccountId);
        return savedContactSearch;
      }
    ).finally(() => this.loadingService.hideLoadingSpinner());
  }

  addSavedContactSearch(savedContactSearch: SavedContactSearch): Observable<Response> {
    //this.authService.reauthenticateIfTokenExpired();

    this.loadingService.displayLoadingSpinner();
    return this.http.post<Response>(
      this.url,
      savedContactSearch
    ).finally(() => this.loadingService.hideLoadingSpinner());
  }

  updateSavedContactSearch(savedContactSearch: SavedContactSearch): Observable<Response> {
    //this.authService.reauthenticateIfTokenExpired();

    this.loadingService.displayLoadingSpinner();
    return this.http.put<Response>(
      this.url + savedContactSearch.id,
      savedContactSearch
    ).finally(() => this.loadingService.hideLoadingSpinner());
  }

  deleteSavedContactSearch(savedContactSearch: SavedContactSearch): Observable<Response> {
    //this.authService.reauthenticateIfTokenExpired();

    this.loadingService.displayLoadingSpinner();
    return this.http.put<Response>(
      this.url + "Delete/" + savedContactSearch.id,
      savedContactSearch
    ).finally(() => this.loadingService.hideLoadingSpinner());
  }
}
